import React from 'react';
import styles from './Button.module.scss';

const Button = ({
    title,
    disabled,
    secondary,
    danger,
    info,
    large,
    width,
    marginRight,
    autoMargin,
    spacing: letterSpacing,
    className,
    onClick: handleClick,
    ...props
}) => {
    const getClassNames = () =>
        `${styles.button} 
        ${large ? styles.large : ''} 
        ${className} 
        ${secondary ? styles.secondary : ''}
        ${danger ? styles.danger : ''}
        ${info ? styles.info : ''}
        ${autoMargin ? styles.autoMargin : ''}
        ${disabled ? styles.disabled : ''}
        `;

    const onClick = (...props) => {
        if (disabled) return;

        handleClick(...props);
    };

    return (
        <button
            className={getClassNames()}
            style={{ width, letterSpacing, marginRight }}
            {...props}
            onClick={onClick}
        >
            {title}
        </button>
    );
};

export default Button;
